import { PageLayout } from "../../components/index";
import { Helmet } from "react-helmet";
import ContactInfo from "./contactInfo/ContactInfo";

const Contact = () => {
  return (
    <PageLayout>
      <Helmet>
        <title>Contact | Exotic Group</title>
        <meta name="description" content="Contact | Exotic Group" />
      </Helmet>

      <ContactInfo />
    </PageLayout>
  );
};

export default Contact;
